<template>
  <div>
    <orders-on-delivery
        :externalClientId="externalClientId"
        :phoneCode="phoneCode"
        :phoneNumber="phoneNumber"
        :userName="userName"
        :items="ondelivery"
    ></orders-on-delivery>

    <orders-delivered
        :externalClientId="externalClientId"
        :phoneCode="phoneCode"
        :phoneNumber="phoneNumber"
        :userName="userName"
        :items="delivered"
    ></orders-delivered>

    <!-- Empty state -->
    <div v-if="hasOrders" class="my-orders__empty">
        <img
            :src="icWarning"
            alt=""
            class="star-icon"
        >

        <p>
            Ainda não fizeste nenhuma encomenda Começa já a comprar!
        </p>
    </div>
  </div>
</template>

<script>
import icWarning from '../../../svg/ic_warning.svg';

export default {
    props: {
        externalClientId: {
            required: true,
        },
        ondelivery: {
            required: true,
            type: Array,
        },
        delivered: {
            required: true,
            type: Array,
        },
        phoneNumber: {
            required: true,
        },
        phoneCode: {
            required: true,
        },
        userName: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            icWarning: icWarning,
            hasOrders: false
        }
    },
    mounted() {

        if(this.ondelivery.length == 0 && this.delivered.length == 0){
            this.hasOrders = true
        } else {
            this.hasOrders = false
        }

    }
}
</script>
